import { createAppSelector, selectTerms } from "./base";
import { selectCourseUsersForCurrentUser } from "./section-user";
import { sortByTermYearRegex } from "./sorting";

export const selectSortedTerms = createAppSelector([selectTerms], (terms) =>
  terms.toSorted(sortByTermYearRegex),
);

export const selectSortedTermsForCurrentUser = createAppSelector(
  [selectCourseUsersForCurrentUser, (state) => state.sections, (state) => state.terms],
  (courseUsers, courseMap, termMap) => {
    const courseIds = new Set(courseUsers.map((cu) => cu.section_id));
    const termIds = new Set(
      Array.from(courseIds).flatMap((courseId) => {
        const course = courseMap[courseId];
        return course ? [course.term_id] : [];
      }),
    );
    return Array.from(termIds)
      .flatMap((termId) => {
        const term = termMap[termId];
        return term ? [term] : [];
      })
      .toSorted(sortByTermYearRegex);
  },
);
